import React from "react";
import Well1Logo from "../../assets/svg/well-1-img.svg";
import Well2Logo from "../../assets/svg/well-2-img.svg";
import Well3Logo from "../../assets/svg/well-3-img.svg";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../store/store";
import { handleSOSUpdate } from "../../store/reducers/authentication/apiThunk";
import { showToast } from "../../components/Toast";
const ChooseBenefits = ({ selectData }: any) => {
  const dispatch = useDispatch<AppDispatch>();

  const arr = [
    {
      id: 1,
      img: Well1Logo,
      name: "Doctor on call",
    },
    {
      id: 2,
      img: Well2Logo,
      name: "Nutrition Coaching",
    },
    {
      id: 3,
      img: Well3Logo,
      name: "Dental Checkup",
    },
    {
      id: 4,
      img: Well1Logo,
      name: "Lab Tests",
    },
    {
      id: 5,
      img: Well2Logo,
      name: "Pharmacy",
    },
    {
      id: 6,
      img: Well3Logo,
      name: "Other Discounts",
    },
  ];

  const handleClick = async () => {
    if (selectData?.livLongTransactionID) {
      const data = {
        prosureCustomerId: selectData?.prosureCustomerId,
        vdf1: selectData?.livLongTransactionID,
      };
      try {
        const res = await dispatch(handleSOSUpdate(data)).unwrap(); // Unwraps to return raw result or throw error
        console.log("handleSOSUpdate", res);
        if (res?.status === 1) {
          window.open(res?.data, '_blank', 'noopener,noreferrer');
        }
      } catch (error) {
        showToast("Something went wrong", "error");
        console.error("Error saving user data:", error);
      }
    }else{
      showToast("No Transaction Done", "error");
    }
  };
  return (
    <div>
      <div className="text-[20px] leading-[26px] font-bold text-text-color-1 hidden sm:flex mt-[67px]">
        Choose Benefits
      </div>
      <div className="grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-3 gap-4 mt-[24px]">
        {arr?.map((item: any) => {
          return (
            <div
              key={item?.id}
              className="bg-white rounded-[16px] lg:p-[24px] p-[10px] flex lg:flex-row flex-col justify-center lg:justify-start text-center border-[1px] lg:border-[0px] border-bg-color-1 sm:border-bg-color-10 items-center text-[12px] leading-[16px] lg:text-[16px] lg:leading-[20px] font-semibold cursor-pointer"
              onClick={handleClick}
            >
              <img
                src={item?.img}
                alt={`${item?.img}`}
                className="mb-[12px] lg:mb-[0] lg:mr-[8px]"
              />
              {item?.name}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChooseBenefits;
